import React from 'react'
import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Divider, Row, Col, Button } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { CodigosTransaccionesConstant, OrigenesContabilidadConstant } from 'constants/index'

import * as PlantillaContabilidadService from 'services/plantillaContabilidad.service'

import * as FormGroups from './formGroups'

export const ValidationSchema = Yup.object().shape({
  descripcion: Yup.string().max(50).required(),
  cuentaContableSoles: Yup.string().required(),
  origen: Yup.string().required(),
  tipoSocio: Yup.string().when('origen', {
    is: OrigenesContabilidadConstant.CANJE_LETRAS,
    then: Yup.string().required()
  })
})

const MainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const formInitialValues = React.useMemo(() => {
    return {
      cuentaContableSoles: editarData.cuentaContableSoles ?? '',
      cuentaContableSolesInfo: editarData.cuentaContableSolesInfo ?? '',
      cuentaContableDolares: editarData.cuentaContableDolares ?? '',
      cuentaContableDolaresInfo: editarData.cuentaContableDolaresInfo ?? '',
      cuentaContableEuros: editarData.cuentaContableEuros ?? '',
      cuentaContableEurosInfo: editarData.cuentaContableEurosInfo ?? '',
      origen: editarData.origen ?? '',
      descripcion: editarData.descripcion ?? '',
      tipoSocio: editarData.tipoSocio ?? ''
    }
  }, [editarData])

  const onSubmit = React.useCallback(
    (formData, { setSubmitting }) => {
      const operacion = editarData._id
        ? () => PlantillaContabilidadService.actualizarxId(editarData._id, formData)
        : () => PlantillaContabilidadService.nuevo(formData)

      operacion()
        .then(() => {
          __zariContext.snack('success', editarData._id ? 'La plantilla se ha actualizado.' : 'La plantilla se ha creado.')
          history.push(`/${CodigosTransaccionesConstant.PLANTILLASCONTABILIDAD_LISTA}`)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, history, editarData._id]
  )

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit} validationSchema={ValidationSchema}>
      {({ errors, touched, isSubmitting, handleSubmit, values, setFieldValue }) => (
        <Form>
          <Row>
            <Col md={4}>
              <FormGroups.OrigenFormGroup iError={errors.origen} iTouched={touched.origen} fIsSubmitting={isSubmitting} />
              <FormGroups.DescripcionFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
              {values.origen === OrigenesContabilidadConstant.CANJE_LETRAS && (
                <FormGroups.TipoSocioFormGroup iError={errors.tipoSocio} iTouched={touched.tipoSocio} fIsSubmitting={isSubmitting} />
              )}
              <FormGroups.CuentaContableSolesFormGroup
                iValue={values.cuentaContableSolesInfo}
                iError={errors.cuentaContableSoles}
                iTouched={touched.cuentaContableSoles}
                setFieldValue={setFieldValue}
              />
              <FormGroups.CuentaContableDolaresFormGroup
                iValue={values.cuentaContableDolaresInfo}
                iError={errors.cuentaContableDolares}
                iTouched={touched.cuentaContableDolares}
                setFieldValue={setFieldValue}
              />
              <FormGroups.CuentaContableEurosFormGroup
                iValue={values.cuentaContableEurosInfo}
                iError={errors.cuentaContableEuros}
                iTouched={touched.cuentaContableEuros}
                setFieldValue={setFieldValue}
              />
              <Divider noMargin />
              <Row>
                <Col md={12} className='text-right'>
                  <Button onClick={handleSubmit}>Guardar</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(MainForm)
